import React from "react";

export default {
    'en_CA': 'English (Canada)',
    'en_US': 'English (United States)',
    'en_GB': 'English (Great Britain)',
    'fr_CA': 'French (Canada)',
    'fr_FR': 'French (France)',
	'fr_BE': 'French (Belgium)',
	'fr_MA': 'French (Morocco)',
    'pt_PT': 'Portuguese (Portugal)',
	'el_GR': 'Greek (Greece)',
	'es_ES': 'Spanish (Spain)',
	'es_MX': 'Spanish (Mexico)',
	'es_CO': 'Spanish (Colombia)',
	'nl_BE': 'Dutch (Belgium)',
	'pt_BR': 'Portuguese (Brazil)',
	'sk_SK': 'Slovak (Slovakia)',
	'sr_RS': 'Serbian (Serbia)',
	'tr_TR': 'Turkish (Turkey)',
    'fi_FI': 'Finnish (Finland)',
    'sv_SE': 'Swedish (Sweden)',
    'WIN_DRAW_WIN': 'Resultado del partido',
    'CORRECT_SCORE': 'Puntuación correcta',
    'TOTAL_GOALS': 'Total de anotaciones',
    'DOUBLE_CHANCE': 'Doble oportunidad',
    'UNDER_OVER': 'Altas/Bajas',
    'UNDER_OVER_25': 'Altas/Bajas 2.5',
    'UNDER_OVER_25_INITIALS': 'Al/Ba 2.5',
    'UNDER_OVER_35_INITIALS': 'Al/Ba 3.5',
    'UNDER_OVER_15': 'Altas/Bajas 1.5',
    'ASIAN_HANDICAP': 'Asian Handicap',
    'HANDICAP': '1X2 Handicap',
    'HANDICAP_FIRST': '1X2 Handicap Local +1',
    'HANDICAP_SECOND': '1X2 Handicap Visita +1',
    'UNDER_OVER_05': 'Bajas/Altas 0.5',
    'UNDER_OVER_35': 'Altas/Bajas 3.5',
    'BOTH_TEAMS_SCORE': 'Ambos equipos anotan',
    'BOTH_TEAMS_SCORE_INITIALS': 'AEA',
    'HOME_TEAM_GOALS': 'Anotaciones del equipo {0}',
    'AWAY_TEAM_GOALS': 'Anotaciones del equipo {1}',
    'MATCH_BETTING_BOTH_TEAMS_SCORE': 'Match Betting Both Teams Score',
    'WINNING_MARGIN': 'Margen de ganancia',
    'CORRECT_SCORE_GROUP': 'Grupo de puntuación correcta',
    'HOME_TEAM_TO_SCORE': '{0} anota',
    'AWAY_TEAM_TO_SCORE': '{1} anota',
    'FIRST_TEAM_TO_SCORE': 'First Team To Score',
    'LAST_TEAM_TO_SCORE': 'Last Team To Score',
    'HALF_TIME_FULL_TIME': 'Descanso Tiempo Completo',
    'TEAM_SCORECAST': 'Pronóstico de Puntuación de Equipo',
    'HALF_TIME_CORRECT_SCORE': 'Puntuación correcta en el descanso',
    'HALF_TIME_RESULT': 'Resultado de medio tiempo',
    'FIRST_LAST_TO_SCORE': 'Primero/Último en anotar',
    'LAST': 'Último',
    'FIRST': 'Primero',
    'IN': 'en',
    'LAST_THREE_GAMES': 'Últimos 3 juegos',
    'PREVIOUS': 'Anterior',
    'EIGHT_RESULTS': '8 partidos',
    'EIGHT_GAMES': '8 juegos',
    'OVER_25': 'Altas de 2.5',
    'UNDER_25': 'Bajas de 2.5',
    'OVER_35': 'Altas de 3.5',
    'UNDER_35': 'Bajas de 3.5',
    'COVERED': 'Cubierto',
    'DID_NOT_COVER': 'No cubrió',
    'SPREAD': 'Margen',
    'TOTAL_POINTS_UNDER_OVER': 'Total de Puntos Bajas/Altas',
    'TOTAL_POINTS_OVER_UNDER': 'Total de Puntos Altas/Bajas',
    'MONEYLINE': 'Money Line',
    'TOTAL_POINTS_GROUP': 'Grupo de total de puntos',
    'MONEY_LINE_TOTAL_POINTS': 'ML y tot pts Al/Ba',
    'SPREAD_TOTAL_POINTS': 'Marg y tot de pts Al/Ba',
    'Argentina': 'Argentina',
    'Belgium': 'Belgium',
    'Brazil': 'Brazil',
    'Colombia': 'Colombia',
    'Costa Rica': 'Costa Rica',
    'Croatia': 'Croatia',
    'Czech Republic': 'Czech Republic',
    'Denmark': 'Denmark',
    'Egypt': 'Egypt',
    'England': 'England',
    'France': 'France',
    'Germany': 'Germany',
    'Greece': 'Greece',
    'Holland': 'Holland',
    'Iceland': 'Iceland',
    'Italy': 'Italy',
    'Mexico': 'Mexico',
    'Poland': 'Poland',
    'Portugal': 'Portugal',
    'Republic of Ireland': 'Republic of Ireland',
    'Russia': 'Russia',
    'Spain': 'Spain',
    'Sweden': 'Sweden',
    'Switzerland': 'Switzerland',
    'Ukraine': 'Ukraine',
    'Uruguay': 'Uruguay',
    'Boston': 'Boston',
    'Cleveland': 'Cleveland',
    'Houston': 'Houston',
    'Los Angeles': 'Los Angeles',
    'Orlando': 'Orlando',
    'Portland': 'Portland',
    'San Antonio': 'San Antonio',
    'Euro Arena': 'Euro Arena',
    'Athens': 'Athens',
    'Real': 'Real',
    'Piraeus': 'Piraeus',
    'Istanbul Blues': 'Istanbul Blues',
    'Fener': 'Fener',
    'Vitoria': 'Vitoria',
    'Tel Aviv Yellows': 'Tel Aviv Yellows',
    'Moscow': 'Moscow',
    'Kaunas': 'Kaunas',
    'Barcelona City': 'Barcelona City',
    'Belgrade': 'Belgrade',
    'Lyon': 'Lyon',
    'Khimki': 'Khimki',
    'Berlin': 'Berlin',
    'St Petersburg': 'St Petersburg',
    'Valencia': 'Valencia',
    'Turkey': 'Turkey',
    'Netherlands': 'Netherlands',
    'Utd': 'United',
    'City': 'City',
    'Liverpool': 'Liverpool',
    'Barcelona': 'Barcelona',
    'Madrid': 'Madrid',
    'Munich': 'Munich',
    'Turin': 'Turin',
    'Milan': 'Milan',
    'Amsterdam': 'Amsterdam',
    'Paris': 'Paris',
    'Pittsburgh': 'Pittsburgh',
    'Philadelphia': 'Philadelphia',
    'Denver': 'Denver',
    'New York': 'New York',
    'New England': 'New England',
    'Green Bay': 'Green Bay',
    'San Francisco': 'San Francisco',
    'Miami': 'Miami',
    'Dallas': 'Dallas',
    'Oakland': 'Oakland',
    'Chicago': 'Chicago',
    'DRAW': 'Empate',
    'HD': '{0}/Empate',
    'DA': 'Empate/{1}',
    'HA': '{0}/{1}',
    'Under 2.5': 'Bajas de 2.5',
    'Over 2.5': 'Altas de 2.5',
    'Under 1.5': 'Bajas de 1.5',
    'Over 1.5': 'Altas de 1.5',
    'Under': 'Bajas de {0}',
    'Over': 'Altas de {0}',
    'HOME': '{0}',
    'AWAY': '{1}',
    'Under 0.5': 'Bajas de 0.5',
    'Over 0.5': 'Altas de 0.5',
    'Under 3.5': 'Bajas de 3.5',
    'Over 3.5': 'Altas de 3.5',
    'Both Score Yes': 'Sí',
    'Both Score No': 'No',
    'Home Not to Score': '{0} Not to Score',
    'Home Exactly 1': '{0} Exactly 1',
    'Home Exactly 2': '{0} Exactly 2',
    'Home Exactly 3': '{0} Exactly 3',
    'Home Exactly 4': '{0} Exactly 4',
    'Away Not to Score': '{1} Not to Score',
    'Away Exactly 1': '{1} Exactly 1',
    'Away Exactly 2': '{1} Exactly 2',
    'Away Exactly 3': '{1} Exactly 3',
    'Away Exactly 4': '{1} Exactly 4',
    'Home to Win and both teams to score': '{0} to Win and both teams to score',
    'Home to Win to nil': '{0} to Win to nil',
    'Score draw': 'Score draw',
    '0-0': '0-0',
    '0-1': '0-1',
    '0-2': '0-2',
    '0-3': '0-3',
    '0-4': '0-4',
    '0-5': '0-5',
    '0-6': '0-6',
    '1-0': '1-0',
    '2-0': '2-0',
    '3-0': '3-0',
    '4-0': '4-0',
    '5-0': '5-0',
    '6-0': '6-0',
    '1-1': '1-1',
    '2-2': '2-2',
    '3-3': '3-3',
    '2-1': '2-1',
    '1-2': '1-2',
    '3-1': '3-1',
    '1-3': '1-3',
    '3-2': '3-2',
    '2-3': '2-3',
    '4-1': '4-1',
    '1-4': '1-4',
    '4-2': '4-2',
    '2-4': '2-4',
    '5-1': '5-1',
    '1-5': '1-5',
    '1-0,2-0,2-1': '1-0,2-0,2-1',
    '3-0,3-1,4-0': '3-0,3-1,4-0',
    '1-1,2-2': '1-1,2-2',
    '0-1,0-2,1-2': '0-1,0-2,1-2',
    '0-3,1-3,0-4': '0-3,1-3,0-4',
    'Away to Win and both teams to score': '{1} to Win and both teams to score',
    'Away to Win to nil': '{1} to Win to nil',
    'Home Win By Exactly 1 Goal': '{0} Win By Exactly 1 Goal',
    'Home Win By Exactly 2 Goals': '{0} Win By Exactly 2 Goals',
    'Home Win By 3 or more goals': '{0} Win By 3 or more goals',
    'Away Win By Exactly 1 Goal': '{1} Win By Exactly 1 Goal',
    'Away Win By Exactly 2 Goals': '{1} Win By Exactly 2 Goals',
    'Away Win By 3 or more goals': '{1} Win By 3 or more goals',
    'Draw With No Goals': 'Draw With No Goals',
    'Draw With Goals': 'Draw With Goals',
    'Any Other': 'Cualquier otro',
    'Home Not To Score': '{0} Not To Score',
    'Home To Score': '{0} anota',
    'Away Not To Score': '{1} Not To Score',
    'Away To Score': '{1} anota',
    'Home': '{0}',
    'No Goal': 'Sin anotaciones',
    'Away': '{1}',
    'Home/Home': '{0}/{0}',
    'Home/Draw': '{0}/Empate',
    'Home/Away': '{0}/{1}',
    'Draw/Home': 'Empate/{0}',
    'Draw/Draw': 'Empate/Empate',
    'Draw/Away': 'Empate/{1}',
    'Away/Home': '{1}/{0}',
    'Away/Draw': '{1}/Empate',
    'Away/Away': '{1}/{1}',
    'Home and 1-0': '{0} and 1-0',
    'Home and 2-0': '{0} and 2-0',
    'Home and 2-1': '{0} and 2-1',
    'Away and 2-1': '{1} and 2-1',
    'Home and 3-0': '{0} and 3-0',
    'Home and 3-1': '{0} and 3-1',
    'Away and 3-1': '{1} and 3-1',
    'Home and 4-0': '{0} and 4-0',
    'Home and 1-1': '{0} and 1-1',
    'Away and 1-1': '{1} and 1-1',
    'Home and 2-2': '{0} and 2-2',
    'Away and 2-2': '{1} and 2-2',
    'Away and 0-1': '{1} and 0-1',
    'Away and 0-2': '{1} and 0-2',
    'Away and 1-2': '{1} and 1-2',
    'Home and 1-2': '{0} and 1-2',
    'Away and 0-3': '{1} and 0-3',
    'Away and 1-3': '{1} and 1-3',
    'Home and 1-3': '{0} and 1-3',
    'Away and 0-4': '{1} and 0-4',
    'Other': 'Otro',
    'Draw': 'Empate',
    '120-124': '120-124',
    '125-129': '125-129',
    '130-134': '130-134',
    '135-139': '135-139',
    '140-144': '140-144',
    '145-149': '145-149',
    '150-154': '150-154',
    '155-159': '155-159',
    '160-164': '160-164',
    '165-169': '165-169',
    '170-174': '170-174',
    '175-179': '175-179',
    'Under 180': 'Bajas de 180',
    '180-184': '180-184',
    '185-189': '185-189',
    '190-194': '190-194',
    '195-199': '195-199',
    '200-204': '200-204',
    '205-209': '205-209',
    '210-214': '210-214',
    '215-219': '215-219',
    '220-224': '220-224',
    '225-229': '225-229',
    '230-234': '230-234',
    '235-239': '235-239',
    '240-244': '240-244',
    '245-249': '245-249',
    'Over 249': 'Altas de 249',
    '26-30': '26-30',
    '31-35': '31-35',
    '36-40': '36-40',
    '41-45': '41-45',
    '46-50': '46-50',
    '25 And Under': 'Bajas de 26',
    '25 And Under Short': 'Bajas de 26',
    '51 And Over': 'Altas de 50',
    '51 And Over Short': 'Altas de 50',
    'and': '&',
    'slash': '/',
    'FIRST_PLAY': '1st Play',
    'SECOND_PLAY': '2nd Play',
    'THIRD_PLAY': '3rd Play',
    'FOURTH_PLAY': '4th Play',
    'FIFTH_PLAY': '5th or More Play',
    'FIELD_GOAL': 'Field Goal',
    'PassTD on 1st Play': 'PassTD on 1st Play',
    'PassTD on 2nd Play': 'PassTD on 2nd Play',
    'PassTD on 3rd Play': 'PassTD on 3rd Play',
    'PassTD on 4th Play': 'PassTD on 4th Play',
    'PassTD on or after 5th Play': 'PassTD on or after 5th Play',
    'RunTD on 1st Play': 'RunTD on 1st Play',
    'RunTD on 2nd Play': 'RunTD on 2nd Play',
    'RunTD on 3rd Play': 'RunTD on 3rd Play',
    'RunTD on 4th Play': 'RunTD on 4th Play',
    'RunTD on or after 5th Play': 'RunTD on or after 5th Play',
    'Turnover on 1st Play': 'Turnover on 1st Play',
    'Turnover on 2nd Play': 'Turnover on 2nd Play',
    'Turnover on 3rd Play': 'Turnover on 3rd Play',
    'Turnover on 4th Play': 'Turnover on 4th Play',
    'Turnover on or after 5th Play': 'Turnover on or after 5th Play',
    'Field Goal': 'Field Goal',
    'Football': 'Americano',
    'Matchday': 'Jornada',
    'Basketball': 'Baloncesto',
    'Dogs': 'Perros',
    'Motor Racing': 'Carreras de autos',
    'Results': 'Resultados',
    'Horses': 'Caballos',
    'Soccer': 'Fútbol',
    'US Football': 'Fútbol Americano',
    'FORECAST': 'Exacta',
    'TRICAST': 'Trifecta',
    'REVERSE_FORECAST': 'Exacta Box',
    'REVERSE_TRICAST': 'Trifecta Box',
    'FIRST_ST': '1',
    'SECOND_ND': '2',
    'THIRD_RD': '3',
    'RD': 'ro.',
    'ST': 'ro.',
    'ND': 'do.',
    'ANY': 'Cualquiera',
    'TO_WIN': 'Para ganar',
    'RACE_CARD': 'Programa de carreras',
    'EACH_WAY': 'Ganar/Posicion',
    'EW': 'G/P',
    'FORECAST_TRICAST': 'Exacta/Trifecta',
    'EACH_WAY_ODDS_PLACE': 'G/P {0} 1-2',
    'EACH_WAY_ODDS_SHOW': 'G/P {0} 1-2-3',
    'EXPAND_ALL': 'Expandir mercados',
    'COLLAPSE_ALL': 'Colapsar mercados',
    'NUMBER': 'Número',
    'SORT_BY': 'Ordenar por',
    'BET_SLIP': 'Comprobante de apuestas',
    'CLOSE_BET_SLIP': 'Cerrar',
    'CLOSE_SLIP': 'Cerrar',
    'PLACED_BETS': 'Colocado',
    'SETTLED_BETS': 'Liquidado',
    'SLIP': 'Comprobante',
    'OPEN_BETS': 'Abierto',
    'CLEAR_SELECTIONS': 'Eliminar selecciones',
    'ADD_TO_BET_SLIP': 'Añadir al comprobante de selecciones',
    'NO_BETS': 'Sin apuestas',
    'COMBINATION_TRICAST': 'Trifecta Box',
    'COMBINATION_FORECAST': 'Exacta Box',
    'TOTAL_STAKE': 'Apuesta total',
    'TOTAL_POTENTIAL_RETURNS': 'Total de devoluciones potenciales',
    'N_A': 'N/A',
    'PLACE_BETS': 'Realizar apuestas',
    'REMOVE_ALL': 'Eliminar todo',
    'POT_RETURNS': 'Bote Devoluciones',
    'RETURNED': 'Devuelto',
    'REFUNDED': 'Reembolsado',
    'OK': 'Aceptar',
    'WIN_INITIAL': 'G',
    'DRAW_INITIAL': 'D',
    'LOSE_INITIAL': 'P',
    'SETTINGS': 'Ajustes',
    'LANGUAGE': 'Idioma',
    'LAYOUT': 'Disposición',
    'ODDS': 'Momio',
    'EN_GB': 'English UK',
    'DECIMAL': 'Decimal',
    'FRACTIONAL': 'Fraccional',
    'AMERICAN': 'Americano',
    'SIMPLIFIED_DESKTOP': 'This is The main class for the desktop simplified UI',
    'SIMPLIFIED_MOBILE': 'This is The main class for the mobile simplified UI',
    'SHOW_VIDEO': 'Show Video',
    'ALERT_NOTIFICATION': 'Alerta',
    'WARNING_NOTIFICATION': 'Precaución',
    'WARNING_NOTIFICATION_REALITY_CHECK': 'Precaución',
    'INFO_NOTIFICATION': 'INFORMACIÓN',
    'SUCCESS_NOTIFICATION': 'Éxito',
    'SELECTION_REMOVAL': 'Esta selección será eliminada en ',
    'SECONDS': ' Segundos',
    'SECOND': ' second',
    'REMOVE_CLOSED_EVENTS': 'Eliminar eventos cerrados',
    'SET_VIDEO_ON_FUL_SCREEN': '¿Colocar el video en pantalla completa?',
    'CANCEL': 'Cancelar',
    'INTERNAL_ERROR': 'Error interno',
    'OPEN_BETS_WARNING': 'Algunas o todas las apuestas abiertas no pudieron ser añadidas a la tarjeta de juego porque pertenecen a eventos pasados.',
    '-32602': 'Una o dos apuestas no se realizaron a tiempo.',
    'OPEN_BETS_ON_BET_SLIP_LIMIT_REACHED': 'Se ha alcanzado el número máximo de selecciones en el boleto de apuestas. Modifique sus selecciones antes realizar su apuesta',
    '-20000': 'Cannot establish connection (Error Code: -20000)',
    '-20001': 'Cannot establish connection (Error Code: -20001)',
    '-20002': 'Too many requests (Error Code: -20002)',
    '-20003': 'Too many requests (Error Code: -20003)',
    '-20004': 'Invalid Request (Error Code: -20004)',
    '-10000': 'Invalid Request (Error Code: -10000)',
    '-10001': 'Invalid Request (Error Code: -10001)',
    '-1000': 'El juego ha sido suspendido. Ponte en contacto con Atención al cliente.',
    '-999': 'La sesión expiró.',
    '-998': 'Jugador suspendido',
    '-997': 'Comando no permitido',
    '-996': 'Error processing request (Error Code: -996)',
    '-995': 'Error processing request (Error Code: -995)',
    '-994': 'Se perdió la conexión con el servidor, la apuesta no se realizó.',
    '-980': 'Error processing request (Error Code: -980)',
    '-979': 'Error processing request (Error Code: -979)',
    '-978': 'No hay fondos suficientes para realizar esta transacción.',
    '-977': 'No se pudo realizar la verificación de existencia.',
    '-976': 'Operación de monedero temporalmente bloqueada.',
    '-975': 'El límite de apuestas se excedió.',
    '-974': 'El límite de pérdidas se excedió.',
    '-973': 'No hay límite establecido.',
    '-972': 'Error de juego responsable.',
    '-971': 'La operación de monedero falló.',
    '-970': 'Se rechazó la transacción de monedero.',
    '-969': 'Error de comunicación de monedero.',
    '-968': 'Error de transacción de monedero.',
    '-967': 'La autenticación falló.',
    '-966': 'Se excedió el umbral de altas ganancias.',
    '-965': 'Se rebasaron los parámetros inválidos.',
    'BET_STAKE_OUT_OF_LIMITS_MESSAGE': 'El monto de una o mas apuestas no es valido. Apuesta mínima: {0}, Apuesta máxima: {1}. Corrija por favor el monto antes de colocar su apuesta.',
    "LIST_BET_STAKE_OUT_OF_LIMITS_MESSAGE": 'Stake limits on {0} are Min {1} & Max {2}',
    'BET_POTENTIAL_RETURNS_OUT_OF_LIMITS_MESSAGE': 'Una o mas ganancia posible excede el limite de pago de {0}. Corrija por favor el monto antes de colocar su apuesta.',
    'BET_NON_DIVISIBLE_MESSAGE': 'One or more bets not divisible by {0} . Please fix this before placing your bets.',
    'SINGLE_BET_COMMIT_MESSAGE': 'You cannot place multiple single bets',
    'REALITY_CHECK_WARNING_MESSAGE_LINE_1': 'La(s) apuesta(s) que esta realizando están sobre {0}.',
    'MIN_STAKE_REALITY_CHECK_WARNING_MESSAGE_LINE_1': 'The bet(s) you are placing are under {0}',
    'REALITY_CHECK_WARNING_MESSAGE_LINE_2': 'Es esto correcto?',
    'REALITY_CHECK_TOTAL_STAKE_SINGLE_EVENT_WARNING': 'Se ha apostado la cantidad máxima de {0}. Por favor seleccione un evento diferente',

    //SIMPLIFIED UI
    'TOTAL_BETS': 'APUESTA TOTAL',
    'PLACE_YOUR_BETS': 'Haz tus apuestas',
    'RACE_START': 'Comienza la carrera',
    'RACE_START_TIME': 'Hora de inicio',
    'BET_SUMMARY': 'Resumen de apuestas',
    'NO_BETS_RESUME': 'No se hicieron apuestas en el evento actual',
    'LIVE': 'EN VIVO',
    'RACERS': 'Corredores',
    'SELECTION': 'Selección',
    'DATE_LOCATION': 'Evento',
    'STAKE': 'Apuesta',
    'BET_TYPE_STAKE': 'Tipo de apuesta / Apuesta',
    'POTENTIAL_RETURNS': 'Ganancias posibles',
    'BET_HISTORY': 'Historial de Apuestas',
    'BET_HISTORY_LABEL': 'Para mas información, selecciona el botón de Historial de apuestas',
    'FILTER_WINS': 'Filtra tus ganancias',
    'NEXT_RACE': 'Siguiente carrera',
    'WIN': 'Ganar',
    'PLACE': 'Segundo',
    'SHOW': 'Tercero',
    'EXACTA': 'Exa',
    'TRIFECTA': 'Tri',
    'NO_WIN': 'SIN GANANCIA',
    'WON': 'GANADOR',
    'LOST': 'PERDEDOR',
    'CURRENT_RACE': 'Carrera actual',
    'BOX': 'CAJA',
    'TO': 'para',
    'PAYS': 'paga',
    'TRIFECTA_BOX': 'combinación de pronósticos triples',
    'EXACTA_BOX': 'Exa Box',
    'FINISH_YOUR_BETS': 'Termina tus apuestas',
    'SELECT_YOUR_BET_BELOW': 'Selecciona sus apuesta abajo',
    'BET': 'apostar',
    'REMOVED': 'eliminado',
    'RESULT': 'Resultado',
    'GOALS': 'Anotaciones',
    'NO_MORE_BETS': 'No mas apuestas',
    'EVENT_LIVE_MSG_LINE_1': 'Evento en vivo Actual',
    'EVENT_LIVE_MSG_LINE_2': 'Selecciona desde arriba',
    'EVENT_LIVE_MSG_LINE_3': 'futuros eventos',
    'NO_FUTURE_EVENTS': 'No hay eventos futuros',
    'AUTHENTICATION_REQUIRED': 'Inicia sesión para continuar',
    'GAME_DISABLED': 'Juego desactivado',
    'GAME_DISABLED_MESSAGE': 'Ponte en contacto con Atención al cliente.',
    'VOIDED': 'CANCELADO',
    'HELP': 'Ayuda',
    'LAST_RESULTS': 'Últimos resultados',
    'NO_LAST_RESULTS': 'No hay últimos resultados',
    'PREVIOUS_RESULTS': 'Resultados anteriores',
    'OFFENSE_PREVIOUS_RESULTS': 'Offence Previous Results',
    'DEFENSE_PREVIOUS_RESULTS': 'Defence Previous Results',
    'NO_LUCK': 'NO LUCK',
    'THIS_TIME': 'THIS TIME',
    'LOOK_FOR_THE_NEXT': 'Buscar el siguiente',
    'SCHEDULED_EVENT': 'evento programado',
    'LOOK_FOR_THE': 'Buscar el',
    'NEXT_SCHEDULED': 'siguiente evento',
    'EVENT': 'programado',
    'RETURNS': 'GANANCIAS',
    'NEXT': 'Siguiente',
    'FUTURE': 'Futura',
    'PLAYING': 'Jugando',

    'ON': 'en',
    'MB_RACE_ON': 'en',
    'MB_RACE_WIN': 'para ganar',
    'MB_RACE_PLACE': 'para realizar',
    'MB_RACE_SHOW': 'para mostrar',
    'MB_RACE_TRIFECTA_BOX': 'combinación de pronósticos triples',
    'MB_RACE_EXACTA_BOX': 'Exa Box',
    'MB_RACE_EXACTA': 'Exa',
    'MB_RACE_TRIFECTA': 'Tri',
    'MB_FOOTBALL_ON': 'en',
    'ADVERTISING_SPACE': 'ESPACIO DE PUBLICIDAD',
    'CLEAR_LAST': 'Eliminar al último',
    'CLEAR_ALL': 'Eliminar todo',
    'ACTIVE_BETS': 'Apuestas activas',
    'ONLY_SHOW_WINS': 'Mostrar solamente las ganancias',
    'MORE': 'Más',
    'BETS': 'Apuestas',
    'LOADING': 'Cargando',
    'BET_SELECTION_MESSAGE': 'Haz tu selección haciendo clic en las probabilidades.',
    'SIMPLE': 'simple',
    'EXOTIC': 'exotic',
    'UNDO': 'deshacer',
    'CLEAR': 'eliminar',
    'HISTORY': 'historial',
    'MARKETS': 'Mercados',
    'MAIN': 'Principal',
    'VS': 'vs',
    'AT': '@',
    'SCORE': 'puntuación',
    'DEFENDS': '(Defends) at',
    'ATTACKS': '(Attacks) at',
    'DETAILS': 'Detalles',
    'NO_GOALS': 'No hay anotaciones',
    'MAX_WINNINGS_REACHED': 'Se alcanzó el máximo de ganancias',
    'MAX_WINNINGS_REACHED_TEXT': 'La apuesta actual excederá el pago máximo de {0}. El valor máximo de apuesta permitido para esta apuesta es de {1}.',
    'NO_CONNECTION_TITLE': 'Se perdió la conexión',
    'NO_CONNECTION_TITLE_TEXT': 'Se perdió la conexión con el servidor, asegúrate de tener una conexión de red estable y actualiza la página. Si el problema persiste, ponte en contacto con Atención al cliente.',
    'PLAYER_LOGGED_OTHER_PLACE_TITLE_TEXT': 'La conexión se cerró, el usuario se conectó dos veces.',
    'BET_CONFIRMED_TEXT': 'none',
    'TAX_NOTIFICATION_TEXT': 'none',
    'THE MANOR GROUND': 'Berners Stadium',
    'METRO STADIUM': 'Metro Stadium',
    'HorsesSprints': 'Wetmore Sprints',
    'Showell Park': 'Showell Park',
    '2FurlongHorses': 'Wetmore Sprints',
    'Sandringham Flats': 'Sandringham Flats',
    'Princess Parkway': 'Princess Parkway',
    'Virtual Arena': 'Virtual Arena',
    'Inspired Arena': 'Inspired Arena',
    'HorsesJumps': 'Inspired Downs',
    'DogFlat': 'Barking Green',
    'Dogs2': 'Barking Green',
    'Victoria Park': 'Victoria Park',
    'Jennison Stadium': 'Jennison Stadium',
    'Circuit': 'Circuit',
    'Speedway Park': 'Inspired Raceway',
    'Auto Raceway': 'Auto Raceway',
    'NO_CONNECTION_TO_VIRGO': 'La conexión se perdió',
    'NO_CONNECTION_TO_VIRGO_TEXT': 'Actualiza la página e inicia sesión.',
    'BROWSER_NOT_SUPPORTED_DETAILS': 'Your current browser is not supported. Please use one of the following browsers: Chrome, Firefox or Safari.',
    'BROWSER_NOT_SUPPORTED': 'El navegador no es compatible',
    'DOWNLOAD_CHROME': 'Descargar Chrome',
    'DOWNLOAD_FIREFOX': 'Descargar Firefox',
    'v': 'V',
    '1': '1',
    'x': 'x',
    '2': '2',
    'at': '@',
    '+10.5': '+10.5',
    '+15.5': '+15.5',
    '+5.5': '+5.5',
    '-10.5': '-10.5',
    '-15.5': '-15.5',
    '-5.5': '-5.5',
    'Over 219.5': 'Altas de 219.5',
    'Under 219.5': 'Bajas de 219.5',
    'Over 214.5': 'Altas de 214.5',
    'Under 214.5': 'Bajas de 214.5',
    'Over 209.5': 'Altas de 209.5',
    'Under 209.5': 'Bajas de 209.5',
    'Over 144.5': 'Altas de 144.5',
    'Under 144.5': 'Bajas de 144.5',
    'Over 149.5': 'Altas de 149.5',
    'Under 149.5': 'Bajas de 149.5',
    'Over 154.5': 'Altas de 154.5',
    'Under 154.5': 'Bajas de 154.5',
    'Over 159.5': 'Altas de 159.5',
    'Under 159.5': 'Bajas de 159.5',
    'Over 164.5': 'Altas de 164.5',
    'Under 164.5': 'Bajas de 164.5',
    'Rolling Downs': 'Rolling Downs',
    'FINISHING_ORDER': 'Orden de finalistas',
    'FORECAST_MARBLE': 'Mejores 2',
    'TRICAST_MARBLE': 'Mejores 3',
    'REVERSE_FORECAST_MARBLE': 'Mejores 2 en cualquier orden',
    'REVERSE_TRICAST_MARBLE': 'Mejores 3 en cualquier orden',
    'TO_WIN_MARBLE': 'Ganar',
    'PLACE_MARBLE': 'Segundo',
    'SHOW_MARBLE': 'Tercero',
    'MARBLE': 'Canica',
    'Rumble Turns': 'Rumble Turns',
    'Maple Downs': 'Maple Downs',
    'BALANCE': 'Saldo',
    'DATE_FORMAT': 'DD/MM/YYYY HH:mm',
    'WINS_THE_GAME': 'Gana el partido',
    'Any': 'Cualquiera',
    'BET_BOTH': 'Bet Both',
    'betSlip_Matchday_English': 'Jornada English',
    'betSlip_Matchday_Turkish': 'Jornada Turkish',
    'betSlip_Matchday_Greek': 'Jornada Greek',
    'betSlip_Soccer': 'Fútbol',
    'betSlip_Horses': 'Caballos',
    'betSlip_Basketball': 'Baloncesto',
    'betSlip_Dogs': 'Perros',
    'betSlip_Motor Racing': 'Carreras de autos',
    'betSlip_US Football': 'Fútbol Americano',
    'betSlip_Marble Racing': 'Carreras de Canicas',
    'POS': 'pos',
    'TEAM': 'Club',
    'P': 'JJ',
    'W': 'JG',
    'D': 'JP',
    'L': 'JE',
    'F': 'GF',
    'A': 'GC',
    'PTS': 'Pts',
    'LEAGUE TABLE': 'Tabla de Liga',
    'TREND': 'Tend',
    'Matchday_Islington': 'ISL',
    'Matchday_City': 'CTY',
    'Matchday_Palace': 'PAL',
    'Matchday_Chelsea': 'CHE',
    'Matchday_Southampton': 'SOU',
    'Matchday_Wolverhampton': 'WOL',
    'Matchday_Sheffield': 'SHE',
    'Matchday_Leicester': 'LEI',
    'Matchday_Newcastle': 'NEW',
    'Matchday_Tottenham': 'TOT',
    'Matchday_West Ham': 'WHA',
    'Matchday_United': 'UTD',
    'Matchday_Leeds': 'LEE',
    'Matchday_Liverpool': 'LIV',
    'Matchday_Everton': 'EVE',
    'Matchday_Aston': 'AST',
    'Matchday_Basaksehir': 'BAS',
    'Matchday_Trabzon': 'TRZ',
    'Matchday_Besiktas': 'BKS',
    'Matchday_Sivas': 'SIV',
    'Matchday_Alanya': 'ALA',
    'Matchday_Galata': 'GLS',
    'Matchday_Fenerbahce': 'FRB',
    'Matchday_Gazientep': 'GAZ',
    'Matchday_Antalya': 'ANT',
    'Matchday_Kasimpasa': 'KAS',
    'Matchday_Goztepe': 'GOZ',
    'Matchday_Gencler': 'ESK',
    'Matchday_Konya': 'BUR',
    'Matchday_Rize': 'RIZ',
    'Matchday_Malatya': 'MAL',
    'Matchday_Kayseri': 'KAY',
    'Matchday_Dikefalos Vora': 'ΔΙΚ',
    'Matchday_Erithrolefkoi': 'ΘΡΥ',
    'Matchday_Enosi': 'ΕΝΩ',
    'Matchday_Peristeri': 'ΠΕΡ',
    'Matchday_Prasinoi': 'ΠΡΑ',
    'Matchday_Kitrinoi Vora': 'ΚΙΤ',
    'Matchday_Nea Smirni': 'ΣΜΥ',
    'Matchday_Xanthi': 'ΞΑΝ',
    'Matchday_Tripoli': 'ΤΡΙ',
    'Matchday_Agrinio': 'ΑΓΡ',
    'Matchday_Larisa': 'ΛΑΡ',
    'Matchday_Lamia': 'ΛΑΜ',
    'Matchday_Ioannina': 'ΙΩΑ',
    'Matchday_Iraklio': 'ΗΡΑ',
    'Matchday_A.O. Rizoupolis': 'ΡΙΖ',
    'Matchday_Volos': 'ΒΟΛ',
    'UNDER_OVER_MATCHDAY': 'Altas/Bajas',
    'UNDER_OVER_05_SHORT': '0.5',
    'UNDER_OVER_15_SHORT': '1.5',
    'UNDER_OVER_25_SHORT': '2.5',
    'UNDER_OVER_35_SHORT': '3.5',
    'UNDER_SHORT': 'Ba',
    'OVER_SHORT': 'Al',
    'FULL TIME': 'FULL TIME',
    'FT': 'TC',
    'System': 'SYSTEM',
    'x1': '(x1)',
    'Multiplier': 'Repeat Bet',
    'Main markets': 'Mer Prin',
    "4RANDOM": "4 Aleatorio",
    "6RANDOM": "6 Aleatorio",
    '8RANDOM': '8 Aleatorio',
    '8FAVS': '8 Favorito',
    'QUICK_SELECT': 'QUICK SELECT',
    'UNDER': 'Bajas',
    'OVER': 'Altas',
    'UNDER_OVER_2_5': 'Altas/Bajas 2.5',
    'UNDER_OVER_3_5': 'Altas/Bajas 3.5',
    'MATCH_RESULT': 'RESULTADO DEL PARTIDO',
    'YES': 'Sí',
    'NO': 'No',
    'REALITY_CHECK_WARNING_YES': 'Sí',
    'REALITY_CHECK_WARNING_NO': 'No',
    'ACCUMULATOR': 'Acumulador',
    '+1G': '+1G',
    'Single': 'Único',
    'Doubles': 'Doble',
    'Trebles': 'Triplicar',
    'Four Folds': '4 Parlay',
    'Five Folds': '5 Parlay',
    'Six Folds': '6 Parlay',
    'Seven Folds': '7 Parlay',
    'Eight Folds': '8 Parlay',
    'MD': 'Jornada{0}',
    'MATCH': 'PARTIDO',
    'INVALID_ACCA': 'Cuando las selecciones aparecen resaltadas, sus selecciones múltiples están restringidas',
    'INVALID_ODDS': 'El valor de los momios es muy alto. Modifique por favor sus selecciones',
    'INVALID_ACCA_MORETHAN_8': 'Las apuestas múltiples no pueden contener más de 8 selecciones de un solo partido',
    'ACCUMULATOR_BOOST': 'Mejora de acumulador',
    'Bonus_Info': ' {0}% de Bono',
    '+': '+',
    'Bonus_Value': 'incluye {0} de bono',
    'ACCUMULATOR_INFO': 'Si su apuesta de acumulador es ganadora, se agregara una bonificación de {0}% - {1}% a sus ganancias. El monto del bono depende del número de selecciones.',
    'BET_TYPE': 'Tipo de apuesta',
    'BOOST': 'Aumentar',
    'BOOST_PERCENTAGE': '{0}%',
    'BOOST_BONUS_START': '{0} o mas acumuladores seleccionados recibirán bono adicional',
    'BOOST_BONUS_UPGRADE': 'Agrega otra selecciona a tu acumulador para recibir un bono adicional',
    'BOOST_BONUS_MAX': 'Ya tienes el máximo de bono por acumulador',
    'Marbles_Euro_1': 'Belgium',
    'Marbles_Euro_2': 'Croatia',
    'Marbles_Euro_3': 'Denmark',
    'Marbles_Euro_4': 'England',
    'Marbles_Euro_5': 'France',
    'Marbles_Euro_6': 'Germany',
    'Marbles_Euro_7': 'Italy',
    'Marbles_Euro_8': 'Netherlands',
    'Marbles_Euro_9': 'Portugal',
    'Marbles_Euro_10': 'Spain',
    'Short_Over': 'Altas de {0}',
    'Short_Under': 'Bajas de {0}',
    'Dikefalos Vora': 'ΔΙΚ',
    'Erithrolefkoi': 'ΘΡΥ',
    'Enosi': 'ΕΝΩ',
    'Peristeri': 'ΠΕΡ',
    'Prasinoi': 'ΠΡΑ',
    'Kitrinoi Vora': 'ΚΙΤ',
    'Nea Smirni': 'ΣΜΥ',
    'Xanthi': 'ΞΑΝ',
    'Tripoli': 'ΤΡΙ',
    'Agrinio': 'ΑΓΡ',
    'Larisa': 'ΛΑΡ',
    'Lamia': 'ΛΑΜ',
    'Ioannina': 'ΙΩΑ',
    'Iraklio': 'ΗΡΑ',
    'A.O. Rizoupolis': 'ΡΙΖ',
    'Volos': 'ΒΟΛ',
    'Dortmund': 'Dortmund',
    'Chelsea': 'Chelsea',
    'Porto': 'Porto',
    'Rome': 'Rome',
    'Benfica': 'Benfica',
    'Celtic': 'Celtic',
    'United': 'United',
    'Marble Racing': 'Carreras de Canicas',
    'Matchday_English': 'Jornada',
    'Matchday_Turkish': 'Jornada',
    'Matchday_Greek': 'Jornada',
    'Soccer_Euro': 'Euro',
    'Soccer_Soccer3_Super_League': 'Súper Liga',
    'Soccer_Soccer3_Greek_League': 'Greek League',
    'Soccer_Super_League': 'Súper Liga',
    'Soccer_World_Cup': 'Copa Mundial',
    'Soccer_Soccer3_World_Cup': 'Copa Mundial',
    'Horses_Sprints': 'Carreras',
    'Horses_Flats': 'Fondo',
    'Horses_Jumps': 'Saltos',
    'Basketball_US1': 'US',
    'Basketball_US2': 'US2',
    'Basketball_Europe': 'Europa',
    'Dogs_Flats': 'Fondo',
    'Dogs_City': 'Cuotas Fijas',
    'Motor_Racing_Stock_Cars': 'Autos de Carreras',
    'Motor_Racing_Indy_Cars': 'Autos Indy',
    'US_Football_NFLA': 'NFLA',
    'US_Football_NFL': 'NFL',
    'US_Football_Football': 'Americano',
    'Marble_Racing_Marbles': 'Canicas',
    'Marble_Racing_Marbles2': 'Arena',
    'Marble_Racing_Marbles_Euro': 'Soccer',
    'Marble_Racing_Marbles_Halloween': 'Halloween',
    'Matchday_English_Matchday_English': 'Jornada',
    'Matchday_Turkish_Matchday_Turkish': 'Jornada',
    'Matchday_Greek_Matchday_Greek': 'Jornada',
    'DEMOPLAY_NOTIFICATION_MESSAGE_LINE_1': 'Please register or log in to place a bet',
    'DEMOPLAY_NOTIFICATION_MESSAGE_LINE_2': ' ',
    'DEMOPLAY_NOTIFICATION_DISMISS': 'Dismiss',
    "Matchday_Moroccan": "Journée",
    "Matchday_Moroccan_Matchday_Moroccan": "Journée",
    "betSlip_Matchday_Moroccan": "Journée",

    //Matchday Moroccan Teams
    "Matchday_Casa Reds": "WYD",
    "Matchday_Casa Greens": "RAJ",
    "Matchday_Fès": "FES",
    "Matchday_El Jadida": "ELJ",
    "Matchday_Berkane": "BKN",
    "Matchday_Feth": "FTH",
    "Matchday_FARabat": "FAR",
    "Matchday_Mohammedia": "MOH",
    "Matchday_Soualem": "SLM",
    "Matchday_Khouribga": "KHO",
    "Matchday_Tanger": "TAN",
    "Matchday_Agadir": "AGA",
    "Matchday_Berrechid": "BER",
    "Matchday_Oujda": "OUJ",
    "Matchday_Safi": "SAF",
    "Matchday_Oued Zem": "ODZ",
    "Matchday_Tétouan": "TET",
    "Matchday_Touarga": "TRG",
    "Matchday_Beni Mellal": "BNM",
    "Matchday_Stade Maroc": "STM",
    "Matchday_Zemamra": "ZMR",

    "Soccer_Soccer3_Moroccan_League": "Moroccan",
    //Soccer3 Moroccan Teams
    "Casa Reds": "Casa Reds",
    "Casa Greens": "Casa Greens",
    "Fès": "Fès",
    "El Jadida": "El Jadida",
    "Berkane": "Berkane",
    "Feth": "Feth",
    "FARabat": "FARabat",
    "Mohammedia": "Mohammedia",
    "Soualem": "Soualem",
    "Khouribga": "Khouribga",
    "Tanger": "Tanger",
    "Agadir": "Agadir",
    "Berrechid": "Berrechid",
    "Oujda": "Oujda",
    "Safi": "Safi",
    "Oued Zem": "Oued Zem",
    "Tétouan": "Tétouan",
    "Touarga": "Touarga",
    "Beni Mellal": "Beni Mellal",
    "Stade Maroc": "Stade Maroc",
    "Zemamra": "Zemamra",
    'DEMOPLAY_NOTIFICATION_OK': 'Aceptar',
    'QUICK_FILL': 'Quick Fill',
    "MAD" : "{0} MAD",

    //Matchday Belgium
    "Matchday_Belgium": "Jornada",
    "Matchday_Belgium_Matchday_Belgium": "Jornada",
    "betSlip_Matchday_Belgium": "Jornada Belgium",
    //Matchday Belgium Teams
    "Matchday_Saint-Gilles": "SAI",
    "Matchday_Club": "CLU",
    "Matchday_Anderlecht": "AND",
    "Matchday_Antwerp": "ANT",
    "Matchday_Gent": "GEN",
    "Matchday_Mechelen": "MEC",
    "Matchday_Charleroi": "CHA",
    "Matchday_Genk": "GNK",
    "Matchday_Brugge": "BRU",
    "Matchday_Sint-Truiden": "SIN",
    "Matchday_Leuven": "LEU",
    "Matchday_Kortrijk": "KOR",
    "Matchday_Liege": "LIE",
    "Matchday_Oostende": "OOS",
    "Matchday_Waregem": "WAR",
    "Matchday_Eupen": "EUP",
    "Matchday_Seraing": "SER",

    //BonusBet
    "Gift_for_You_Heading" :"A GIFT FOR YOU",
    "Gift_for_You_Content": "Congratulations! You have promotional offers to redeem.",
    "View_Offers" : "VIEW OFFERS",
    "Do_Not_Show_MSG": "DO NOT SHOW AGAIN",
    "MY_OFFERS" : 'MY OFFERS',
    "SELECT_OFFER" : 'SELECT YOUR OFFER',
    "NO_OFFER" : 'THERE ARE NO ACTIVE OFFERS',
    "CHOOSE_BET": 'CHOOSE BET',
    "Opt_In": 'OPT IN',
    "Key_Terms_Heading" :"KEY TERMS",
    "No_Thanks" : "NO THANKS",
    "PROMO_BET": 'PROMO BET',
    "Time_To_Bet": "TIME TO BET",
    "OPTED_IN_MSG": "THANKS, YOU HAVE OPTED IN",
    "EXP": "Exp.",
    "SELECT": "Select",
    "DEMO_SITE_PROMO_NOT_AVAILABLE": "This demo site does not currently offer any promos. Please log in/register to access current offers. !",
    "Horses_US_Horses": "USA",

    //cricket
    "Cricket" : "Cricket",
    "Cricket_International": "Internacional",
    "betSlip_Cricket": "Cricket",
    //circket teams
     "Australia":"Australia",
     "India":"India",
     "Pakistan":"Pakistan",
     "West Indies" : "West Indies",
     "Sri Lanka":"Sri Lanka",
     "New Zealand":"New Zealand",
     "South Africa":"South Africa",
     "Australia_short":"AUS",
     "WestIndies_short" : "WI",
     "SriLanka_short":"SRI",
     "NewZealand_short":"NZL",
     "India_short":"IND",
     "SouthAfrica_short":"RSA",
     "Pakistan_short":"PAK",
     "England_short": "ENG",
     "Tie":"Tie",
    //cricket markets
     "MATCH_WINNER":"Ganador del partido",
     "TOTAL_SIXES_IN_MATCH":"Total de 6 carreras en el partido",
     "TOTAL_SIXES_IN_MATCH_SHORT": "Bajas 1.5",
     "TOTAL_FOUR_IN_MATCH":"Total de 4 carreras en el partido",
     "TOTAL_BOUNDARIES_IN_MATCH":"Total de veces en el partido",
     "FIRST_TEAM_TOTAL_RUNS":"{0} Total de carreras",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL":"Carreras en el primer lanzamiento",
     "FIRST_TEAM_WICKET_LOST":"{0} Wicket perdido",
     "FIRST_TEAM_WICKET_LOST_DISMISSAL_TYPE": "{0} Primer método de tipo de eliminación",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05_SHORT": "0.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15_SHORT": "1.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25_SHORT": "2.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35_SHORT": "3.5",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_UNDER_OVER":"{0} Carreras de la primera bola, más de/menos de",
     "FIRST_TEAM_RUN_OFF_FIRST_BALL_OVER_UNDER_05": "{0} Carreras de la primera bola, más de/menos de",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_15": "{0} Carreras de la primera bola, más de/menos de",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_25": "{0} Carreras de la primera bola, más de/menos de",
     "FIRST_TEAM_RUNS_OFF_FIRST_BALL_OVER_UNDER_35": "{0} Carreras de la primera bola, más de/menos de",
     "Caught" : "Atrapadas",
     "Bowled":"Golpeados",
     "LBW":"Pierna antes del wicket",
     "No Wicket":"Sin wicket",
     "OverZeroPointFive": "Altas 0.5",
     "UnderZeroPointFive": "Bajas 0.5",
     "OverOnePointFive": "Altas 1.5",
     "UnderOnePointFive": "Bajas 1.5",
     "OverTwoPointFive": "Altas 2.5",
     "UnderTwoPointFive": "Bajas 2.5",
     "OverThreePointFive": "Altas 3.5",
     "UnderThreePointFive": "Bajas 3.5",
     "Yes": "Sí",
     "No":"No",
     "FINAL_SCORE":"Final Score",
     OVER_145: 'Altas 14.5',
     UNDER_145: 'Bajas 14.5',
    DRAW_Cricket: "DRAW",
     //TENNIS
     TOTAL_POINTS:"Puntos totales",
     HANDICAP_TENNIS: "Hándicap",
     Scotland :"Scotland",
     USA: "USA",
     Tennis_International: "Internacional",
     betSlip_Tennis: "Tenis",
     "Win By 2 or 3": "Gana por 3 puntos o menos",
     "Win By 4 or 5": " Gana por 4 o 5 puntos",
     "Win By 6 or 7": "Gana por 6 o 7 puntos",
     "Tennis": "Tenis",
    //baseball
     WINNER : "VICTORIA",
     TOTAL_HOME_RUNS_UNDER_OVER: "TOTAL DE CUADRANGUALARES MÁS/MENOS",
     TOTAL_HOME_RUNS:  "TOTAL DE CUADRANGUALARES EXACTO",
     WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER:"VICTORIA Y TOTAL DE CUADRANGUALARES MÁS/MENOS DE 5,5",
     WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER_SHORT:"Victoria y total de cuadrangulares más/menos 5,5",
     BATTER1_HOME_RUNS: "{0} CUADRANGUALARES",
     BATTER2_HOME_RUNS: "{1} CUADRANGUALARES",
     Baseball_HR_ShootOut_Legends: "Home Runs Shootout-Legends",
     Baseball_HR_ShootOut_Legends_SHORT: "HR Shootout",
     "Baseball": "Béisbol",
     "betSlip_Baseball": "Béisbol",
     "Player 1 AND OVER_5_5":"{0} y más de 5,5",
     "Player 2 AND OVER_5_5":"{0} y más de 5,5",
     "Player 1 AND UNDER_5_5":"{0} y menos de 5,5",
     "Player 2 AND UNDER_5_5":"{0} y menos de 5,5",
     "Draw AND OVER_5_5":"Empate y más de 5,5",
     "Draw AND UNDER_5_5":"Empate y menos de 5,5",
     "HOME RUNS":"{0} CUADRANGUALARES",
     "Next Fixtures":"Next Fixtures",
     "MATCH_IN_PROGRESS": "Match In Progress",
     "Matchday_Light_English": "Matchday Light",
     "Matchday_Light_English_Matchday_Light_English": "English League",
     "betSlip_Matchday_Light_English": "Matchday Light",

     //NFL
    'Cardinals' : 'Cardinals',
    'Falcons' : 'Falcons',
    'Ravens' : 'Ravens',
    'Bills' : 'Bills',
    'Panthers' : 'Panthers',
    'Bears' : 'Bears',
    'Bengals' : 'Bengals',
    'Browns' : 'Browns',
    'Cowboys' : 'Cowboys',
    'Broncos' : 'Broncos',
    'Lions' : 'Lions',
    'Packers' : 'Packers',
    'Texans' : 'Texans',
    'Colts' : 'Colts',
    'Jaguars' : 'Jaguars',
    'Chiefs' : 'Chiefs',
    'Raiders' : 'Raiders',
    'Chargers' : 'Chargers',
    'Rams' : 'Rams',
    'Dolphins' : 'Dolphins',
    'Vikings' : 'Vikings',
    'Patriots' : 'Patriots',
    'Saints' : 'Saints',
    'Giants' : 'Giants',
    'Jets' : 'Jets',
    'Eagles' : 'Eagles',
    'Steelers' : 'Steelers',
    '49ers' : '49ers',
    'Seahawks' : 'Seahawks',
    'Buccaneers' : 'Buccaneers',
    'Titans' : 'Titans',
    'Commanders' : 'Commanders',
    'NEW' : 'New',
    //Soccer_Soccer3_Turkish_League team names and game name
    "Soccer_Soccer3_Turkish_League": "Turkish League",
    "Basaksehir": "BAS",
    "Trabzon": "TRZ",
    "Besiktas": "BKS",
    "Sivas": "SIV",
    "Alanya": "ALA",
    "Galata": "GLS",
    "Fenerbahce": "FRB",
    "Gazientep": "GAZ",
    "Antalya": "ANT",
    "Kasimpasa": "KAS",
    "Goztepe": "GOZ",
    "Gencler": "ESK",
    "Konya": "BUR",
    "Rize": "RIZ",
    "Malatya": "MAL",
    "Kayseri": "KAY",

    //NBA 
  "Basketball_NBA": "NBA",
  "Atlanta Hawks": "Atlanta Hawks",
  "Boston Celtics": "Boston Celtics",
  "Brooklyn Nets": "Brooklyn Nets",
  "Charlotte Hornets": "Charlotte Hornets",
  "Chicago Bulls": "Chicago Bulls",
  "Cleveland Cavaliers": "Cleveland Cavaliers",
  "Dallas Mavericks": "Dallas Mavericks",
  "Denver Nuggets": "Denver Nuggets",
  "Detroit Pistons": "Detroit Pistons",
  "Golden State Warriors": "Golden State Warriors",
  "Houston Rockets": "Houston Rockets",
  "Indiana Pacers": "Indiana Pacers",
  "Los Angeles Clippers": "Los Angeles Clippers",
  "Los Angeles Lakers": "Los Angeles Lakers",
  "Memphis Grizzlies": "Memphis Grizzlies",
  "Miami Heat": "Miami Heat",
  "Milwaukee Bucks": "Milwaukee Bucks",
  "Minnesota Timberwolves": "Minnesota Timberwolves",
  "New Orleans Pelicans": "New Orleans Pelicans",
  "New York Knicks": "New York Knicks",
  "Oklahoma City Thunder": "Oklahoma City Thunder",
  "Orlando Magic": "Orlando Magic",
  "Philadelphia 76ers": "Philadelphia 76ers",
  "Phoenix Suns": "Phoenix Suns",
  "Portland Trail Blazers": "Portland Trail Blazers",
  "Sacramento Kings": "Sacramento Kings",
  "San Antonio Spurs": "San Antonio Spurs",
  "Toronto Raptors": "Toronto Raptors",
  "Utah Jazz": "Utah Jazz",
  "Washington Wizards": "Washington Wizards",
  "TOTALPOINTS": "TOTAL POINTS"
};



// WEBPACK FOOTER //
// ./src/localization/es_MX.js